import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

//console.log("map-sectioncards-v3.js initialized");

let mapInstance = null;
let allMarkersData = [];
let currentView = 'list'; // 'list' o 'map'
let mapMarkers = []; // Almacenar referencias a los marcadores actual

document.addEventListener('DOMContentLoaded', function () {
    const mapContainer = document.getElementById('map');
    const cardsContainer = document.getElementById('cards-container');
    
    if (!mapContainer) {
        console.warn('No map container found');
        return;
    }

    // Get access token from data attribute
    const accessToken = mapContainer.dataset.accessToken;
    
    if (!accessToken) {
        console.error('No access token found for Mapbox');
        return;
    }

    mapboxgl.accessToken = accessToken;

    // Gather markers from .card-item elements
    function gatherMarkers() {
        const points = [];
        const cards = document.querySelectorAll('.card-item');
        
        //console.log('card-item elements found:', cards.length);
        
        cards.forEach(card => {
            const lat = parseFloat(card.dataset.lat);
            const lng = parseFloat(card.dataset.lon);
            
            //console.log('Card data:', { lat, lng, name: card.dataset.name });
            
            if (!isNaN(lat) && !isNaN(lng) && isFinite(lat) && isFinite(lng)) {
                points.push({
                    lat,
                    lng,
                    name: card.dataset.name || 'Sin nombre',
                    slug: card.dataset.slug || '',
                    element: card
                });
            }
        });
        
        return points;
    }

    allMarkersData = gatherMarkers();
    //console.log('Total markers found:', allMarkersData.length, allMarkersData);

    // Function to get visible markers (not hidden by search/filter)
    function getVisibleMarkers() {
        return allMarkersData.filter(marker => {
            if (!marker.element) return false;
            
            // Check if element is visible
            const style = window.getComputedStyle(marker.element);
            const isHidden = style.display === 'none' || style.visibility === 'hidden';
            
            return !isHidden;
        });
    }

    // Function to add markers to map
    function addMarkersToMap(markersToAdd) {
        //console.log('Adding markers to map:', markersToAdd.length);
        
        if (markersToAdd.length === 0) {
            console.warn('No markers to display');
            return;
        }

        // Clear existing markers
        mapMarkers.forEach(marker => marker.remove());
        mapMarkers = [];

        // Add new markers
        const bounds = new mapboxgl.LngLatBounds();

        markersToAdd.forEach(item => {
            bounds.extend([item.lng, item.lat]);

            const popup = new mapboxgl.Popup({ offset: 25 }).setHTML(
                `<strong>${item.name}</strong>`
            );

            const marker = new mapboxgl.Marker({ color: '#3b82f6' })
                .setLngLat([item.lng, item.lat])
                .setPopup(popup)
                .addTo(mapInstance);

            mapMarkers.push(marker);
        });

        // Fit bounds with padding
        if (markersToAdd.length > 1 && !bounds.isEmpty()) {
            mapInstance.fitBounds(bounds, { 
                padding: 50, 
                maxZoom: 15, 
                duration: 800 
            });
        } else if (markersToAdd.length === 1) {
            mapInstance.setCenter([markersToAdd[0].lng, markersToAdd[0].lat]);
            mapInstance.setZoom(14);
        }

        //console.log('Map markers updated with', markersToAdd.length, 'markers');
    }

    // Function to update map markers (for search/filters)
    function updateMapMarkers() {
        if (!mapInstance || currentView === 'list') {
            //console.log('Map not initialized or in list view, skipping marker update');
            return;
        }

        const visibleMarkers = getVisibleMarkers();
        //console.log('Visible markers after filter:', visibleMarkers.length);
        
        addMarkersToMap(visibleMarkers);
    }

    // Function to initialize the map
    function initializeMap() {
        //console.log('initializeMap called, mapInstance exists:', !!mapInstance);
        //console.log('Container dimensions:', mapContainer.getBoundingClientRect());
        
        if (mapInstance) {
            //console.log('Map already exists, resizing...');
            mapInstance.resize();
            updateMapMarkers(); // Update markers when switching back to map
            return;
        }

        if (allMarkersData.length === 0) {
            console.warn('No markers data');
            mapContainer.innerHTML = '<p class="text-center p-5">No hay localizaciones disponibles</p>';
            return;
        }

        //console.log('Creating new map with markers:', allMarkersData[0]);
        
        // Ensure container has dimensions
        if (!mapContainer.style.height || mapContainer.style.height === '') {
            mapContainer.style.height = '500px';
        }
        if (!mapContainer.style.width || mapContainer.style.width === '') {
            mapContainer.style.width = '100%';
        }

        // Initialize map
        mapInstance = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/mapbox/streets-v11',
            center: [allMarkersData[0].lng, allMarkersData[0].lat],
            zoom: allMarkersData.length === 1 ? 14 : 10
        });

        mapInstance.on('load', function () {
            //console.log('Map loaded, adding initial markers...');
            // Load all markers initially
            addMarkersToMap(allMarkersData);
        });

        mapInstance.on('error', function(e) {
            console.error('Map error:', e);
        });
    }

    // Setup MutationObserver to detect changes in cards-container
    if (cardsContainer) {
        const observer = new MutationObserver(function(mutations) {
            //console.log('Cards container changed, updating markers...');
            
            // Re-gather markers as new cards might have been added/removed
            allMarkersData = gatherMarkers();
            
            // Update map markers if map is visible
            updateMapMarkers();
        });

        observer.observe(cardsContainer, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class', 'data-lat', 'data-lon']
        });

        //console.log('MutationObserver set up for cards-container');
    }

    // Handle view toggle button
    const viewToggleBtn = document.getElementById('viewToggleBtn');
    const listView = document.getElementById('listView');
    const mapView = document.getElementById('mapView');
    const toggleFiltersBtn = document.getElementById('toggleFiltersBtn');
    const filtersSidebar = document.getElementById('filters-sidebar');
    const clearFiltersBtn = document.getElementById('clear-filters');

    //console.log('UI Elements:', { viewToggleBtn: !!viewToggleBtn, listView: !!listView, mapView: !!mapView });

    if (viewToggleBtn) {
        // Ensure data attributes exist
        if (!viewToggleBtn.dataset.labelMap) {
            viewToggleBtn.dataset.labelMap = 'Ver en mapa';
        }
        if (!viewToggleBtn.dataset.labelList) {
            viewToggleBtn.dataset.labelList = 'Ver en listado';
        }

        viewToggleBtn.addEventListener('click', function () {
            //console.log('Toggle button clicked, current view:', currentView);
            currentView = currentView === 'list' ? 'map' : 'list';
            //console.log('New view:', currentView);
            
            if (currentView === 'map') {
                // Show map view
                //console.log('Showing map view');
                listView.style.display = 'none';
                mapView.style.display = 'flex';
                mapView.style.flexDirection = 'column';
                viewToggleBtn.textContent = viewToggleBtn.dataset.labelList;
                viewToggleBtn.classList.add('mostrarListado');
                viewToggleBtn.classList.remove('mostrarMapa');
                
                // Initialize map after showing it
                setTimeout(() => {
                    //console.log('Initializing map after toggle');
                    initializeMap();
                    updateMapMarkers();
                }, 150);
            } else {
                // Show list view
                //console.log('Showing list view');
                listView.style.display = 'flex';
                mapView.style.display = 'none';
                viewToggleBtn.textContent = viewToggleBtn.dataset.labelMap;
                viewToggleBtn.classList.add('mostrarMapa');
                viewToggleBtn.classList.remove('mostrarListado');
            }
            
            sessionStorage.setItem('sectionCardsView', currentView);
        });
    }

    // Restore previous view from sessionStorage
    const savedView = sessionStorage.getItem('sectionCardsView');
    if (savedView === 'map' && window.innerWidth > 768) {
        currentView = 'map';
        if (listView && mapView) {
            listView.style.display = 'none';
            mapView.style.display = 'flex';
            mapView.style.flexDirection = 'column';
            if (viewToggleBtn) {
                viewToggleBtn.textContent = viewToggleBtn.dataset.labelList;
                viewToggleBtn.classList.add('mostrarListado');
                viewToggleBtn.classList.remove('mostrarMapa');
            }
        }
        setTimeout(() => {
            initializeMap();
        }, 150);
    } else {
        // Initialize map on desktop by default
        if (window.innerWidth > 768) {
            setTimeout(() => {
                initializeMap();
            }, 500);
        }
    }

    // Handle filters sidebar toggle
    if (toggleFiltersBtn && filtersSidebar) {
        toggleFiltersBtn.addEventListener('click', function () {
            const isVisible = filtersSidebar.style.display !== 'none';
            filtersSidebar.style.display = isVisible ? 'none' : 'block';
            toggleFiltersBtn.classList.toggle('active', !isVisible);

            // Añadir/remover clase with-filters al contenedor de cards y mapa
            if (!isVisible) {
                listView?.classList.add('with-filters');
                mapView?.classList.add('with-filters');
            } else {
                listView?.classList.remove('with-filters');
                mapView?.classList.remove('with-filters');
            }

            // Si el mapa está visible, forzar resize para que se reajuste
            if (mapInstance && currentView === 'map') {
                requestAnimationFrame(() => {
                    mapInstance.resize();
                });
            }
        });
    }

    // Handle clear filters button
    if (clearFiltersBtn) {
        clearFiltersBtn.addEventListener('click', function () {
            document.querySelectorAll('.zone-filter').forEach(cb => { cb.checked = false; });
            // Dispatch the same event app-public.js listens for
            document.querySelectorAll('.card-item').forEach(card => {
                card.classList.remove('hidden');
            });
            updateMapMarkers();
        });
    }
});
